export enum EntityFeatureCategoryType {
    ORGANIZATIONAL_UNIT = "ou_feature",
    SARCAT = "sarcat_feature",
    INBOX_QUOTA = "inbox_quota_feature",
    INBOX = "inbox_feature",
    PROMOTER = "promoter_feature",
    BASIC_AUTO = "basic_auto_feature",
    REDO = "redo_feature"
}

export const ENTITY_FEATURE_CATEGORY_TYPE = [
    { id: EntityFeatureCategoryType.ORGANIZATIONAL_UNIT, name: "Unitats organitzatives" },
    { id: EntityFeatureCategoryType.SARCAT, name: "S@RCAT" },
    { id: EntityFeatureCategoryType.INBOX_QUOTA, name: "Bústies Quota" },
    { id: EntityFeatureCategoryType.INBOX, name: "Bústies" },
    { id: EntityFeatureCategoryType.PROMOTER, name: "Prestador" },
    { id: EntityFeatureCategoryType.BASIC_AUTO, name: "Permís bàsic als usuaris creats automàticament" },
    { id: EntityFeatureCategoryType.REDO, name: "REDO" }
]

export const ENTITY_FEATURE_CATEGORY_TYPE_MAP = new Map(
    ENTITY_FEATURE_CATEGORY_TYPE.map(item => [item.id, item.name])
)

